import type { FC } from 'react';
import { useCallback, useContext, useState } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import LabelsForm from '@wix/da-submit-shared/pkg/common/LabelsForm';
import DesktopBatchActionWrapper from '../DesktopBatchActionWrapper';
import MobileBatchActionWrapper from '../MobileBatchActionWrapper';
import { BatchEditLabel } from '../../../types/batchActions';
import { BatchActionProps } from '../types';

export interface Props extends BatchActionProps {
  batchEditLabels: (labels: BatchEditLabel[]) => void;
}

const LabelsBatchEdit: FC<Props> = ({ selectionArea, batchEditLabels }) => {
  const isMobile = useContext(MobileContext);
  const [value, setValue] = useState<BatchEditLabel[] | undefined>([]);
  const [isValid, setIsValid] = useState(false);
  const handleSave = useCallback(() => {
    value && batchEditLabels(value);
  }, [value, batchEditLabels]);

  const form = (
    <LabelsForm currentValue={value || []} setValue={setValue} onValidation={setIsValid} />
  );

  if (isMobile) {
    return (
      <MobileBatchActionWrapper
        onSave={handleSave}
        disableSave={!isValid}
        restrictSave="non_core_multiple"
      >
        {form}
      </MobileBatchActionWrapper>
    );
  }

  return (
    <DesktopBatchActionWrapper
      selectionArea={selectionArea}
      onSave={handleSave}
      disableSave={!isValid}
      restrictSave="non_core_multiple"
    >
      {form}
    </DesktopBatchActionWrapper>
  );
};
LabelsBatchEdit.displayName = 'LabelsBatchEdit';

export default LabelsBatchEdit;
